import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./page/home";
import Expired from "./page/home/expired";
import Process from "./page/home/process";
import Login from "./page/login";
import Quiz from "./page/quiz";
// import Policy from "./page/quiz/policy";
import QuizComplete from "./page/quiz/complete";
import Register from "./page/register";
import Complete from "./page/register/complete";
import NotFound from "./page/notfound";
import Condition from "./page/login/condition";

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/register/:id" element={<Register />} />
        <Route exact path="/register/:id/complete" element={<Complete />} />
        <Route exact path="/register/:id/:eventname" element={<Register />} />

        <Route exact path="/login/:id/condition" element={<Condition />} />
        <Route exact path="/login/:id/:eventname" element={<Login />} />
        <Route exact path="/login/:id" element={<Login />} />

        {/* <Route exact path="/quiz/policy" element={<Policy />} /> */}
        <Route exact path="/quiz/:id" element={<Quiz />} />
        <Route exact path="/quiz/:id/complete" element={<QuizComplete />} />
        <Route exact path="/quiz/:id/:eventname" element={<Quiz />} />
        <Route exact path="/notfound" element={<NotFound />} />
        <Route exact path="/:eventid" element={<Home />} />
        <Route exact path="/:eventid/:eventname" element={<Home />} />
        <Route exact path="/expired" element={<Expired />} />
        <Route exact path="/process" element={<Process />} />
      </Routes>
    </Router>
  );
}

export default App;
